/**
 * @generated SignedSource<<29fa80900eef38b2334b9d2ea97e3baa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListFocus_listWidget$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetList_widgetList">;
  readonly " $fragmentType": "ListFocus_listWidget";
};
export type ListFocus_listWidget$key = {
  readonly " $data"?: ListFocus_listWidget$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListFocus_listWidget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListFocus_listWidget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetList_widgetList"
    }
  ],
  "type": "WidgetList",
  "abstractKey": null
};

(node as any).hash = "15c8153c4cfe36ab05bebd0fd64eedb5";

export default node;
